import { render, staticRenderFns } from "./IllustrationGradientsSection.vue?vue&type=template&id=5444180f"
import script from "./IllustrationGradientsSection.vue?vue&type=script&lang=ts"
export * from "./IllustrationGradientsSection.vue?vue&type=script&lang=ts"
import style0 from "./IllustrationGradientsSection.vue?vue&type=style&index=0&id=5444180f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports